function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="11" height="11" viewBox="0 0 11 11" {...props}><path d="M9.281 0a1.719 1.719 0 0 1 1.375 2.75l-.687.688L7.563 1.03 8.25.344A1.71 1.71 0 0 1 9.281 0zM.687 7.906L0 11l3.094-.688 6.36-6.359-2.407-2.406-6.36 6.36zm7-4L2.874 8.718l-.592-.592 4.812-4.813.593.593z" /></svg>;
});